import { render, staticRenderFns } from "./topVideoList.vue?vue&type=template&id=c4e486d4&scoped=true"
import script from "./topVideoList.vue?vue&type=script&lang=js"
export * from "./topVideoList.vue?vue&type=script&lang=js"
import style0 from "./topVideoList.vue?vue&type=style&index=0&id=c4e486d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e486d4",
  null
  
)

export default component.exports